import {
  FormGroup,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { Container } from 'containers/LawyerLegalProceedingsPage/Contestation/styled-components';
import React, { FC, useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { DOCUMENT_TYPES } from 'constants/global';
import { ContestationDoc } from 'containers/CourtManagerLegalProceedings/constants';
import { EMPTY_DOCUMENT } from 'containers/data-structure';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { CONTESTATION_ID } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import styled from 'styled-components';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import { get, isEmpty } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import {
  findContestationNatureTitle,
  getContestationDecision,
  hasAmountDecision,
} from 'containers/LawyerLegalProceedingsPage/Contestation/utils';
import ProvisionAmountForm from 'containers/LawyerLegalProceedingsPage/Contestation/ProvisionAmountForm';
import Document from 'components/Document';
import { handleOpenDocument } from 'services/utils';
import View from 'components/SahamIcons/View';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
export const StyledInputLabel = styled(InputLabel)`
  margin-top: 22px;
  padding: 10px;
  border-radius: 5px;
  color: black;
  box-shadow: 0px 1px 3px #000;
  height: 36px;
`;

export const StyledTextField = styled(TextField)`
  margin-left: 18px;
  margin-top: 6px;
`;
export interface ContestionDecisionFormProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  documentId: any;
  setDocumentId: Function;
  judgementOnMerits: any;
  listings: Listings;
  claimNumber?: string;
  contestationDocs: any;
  setContestationDocs: Function;
  contestationId?: number;
  requestUploadContestationDocument?: Function | undefined;
  isLawyer?: boolean;
  handleSuccessCallback?: Function;
  decisionDocuments: any;
  isCivilProceeding?: boolean;
  disabled?: boolean;
  requestGetDocByDocumentumId: Function;
}

export const ContestionDecisionForm: FC<ContestionDecisionFormProps> = props => {
  const [contestationDecisionDoc, setContestationDecisionDoc] = useState<
    ContestationDoc
  >({
    ...EMPTY_DOCUMENT,
  });
  const decisionDocumentToUpdate =
    get(props.judgementOnMerits, 'jom.jmc.jmcd', []).find((jmcd: any) =>
      jmcd.type.startsWith(DOCUMENT_TYPES.CONTESTATION),
    ) || {};

  const [showAmount, setShowAmount] = React.useState<boolean>(false);

  const [contestationNatureTitle, setContestationNatureTitle] = React.useState<
    any
  >(null);
  const [contestationDecision, setContestationDecision] = React.useState<any>(
    {},
  );

  const [contestationNatureId, setContestationNatureId] = React.useState<
    number | null
  >(null);

  const setContestationDecisionDocument = (document: CorporealDocument) => {
    if (!isEmpty(decisionDocumentToUpdate)) {
      let decisionDocuments = { ...props.contestationDocs };
      decisionDocuments = {
        ...decisionDocuments,
        name: document.name,
        type: document.type,
        url: document.url,
      };
      setContestationDecisionDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setContestationDocs(decisionDocuments);
    }

    if (
      CONTESTATION_ID === props.documentId &&
      isEmpty(decisionDocumentToUpdate)
    ) {
      setContestationDecisionDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setContestationDocs({
        ...props.contestationDocs,
        ...{
          contestId: props.contestationId,
          name: document.name,
          type: document.type,
          url: document.url,
          dec: !isEmpty(contestationDecision)
            ? [...Object.values(contestationDecision)]
            : undefined,
        },
      });
    }
  };
  useEffect(() => {
    props.setContestationDocs(decisionDocumentToUpdate);
    setContestationNatureTitle(
      get(props.judgementOnMerits, 'jom.jmc.jomDecisionNatureId', null),
    );
    const decisionToUpdate = getContestationDecision(decisionDocumentToUpdate);
    setContestationDecision(decisionToUpdate);
    setShowAmount(
      hasAmountDecision(
        get(props.judgementOnMerits, 'jom.jmc.jomDecisionNatureId', null),
        get(props.listings, 'judgementOnMeritsContestationNature', []),
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementOnMerits]);

  const onChangeSelect = (event: React.ChangeEvent<{ value: any }>) => {
    const { value } = event.target;
    setContestationNatureId(value);
    const withAmountDecision = hasAmountDecision(
      value,
      get(props.listings, 'judgementOnMeritsContestationNature', []),
    );
    setShowAmount(withAmountDecision);
    setContestationNatureTitle(value);
    if (!withAmountDecision) {
      props.setContestationDocs({
        ...props.contestationDocs,
        dec: get(props.contestationDocs, 'dec', []).map((item: any) => ({
          ...item,
          isDeleted: true,
        })),
      });
    }
  };
  useEffect(() => {
    !isEmpty(props.contestationDocs) &&
      isEmpty(get(decisionDocumentToUpdate, 'dec', [])) &&
      props.setContestationDocs({
        ...props.contestationDocs,
        dec: !isEmpty(contestationDecision)
          ? [...Object.values(contestationDecision)]
          : undefined,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contestationDecision, props.judgementOnMerits]);

  const validateUpload = () => {
    props.requestUploadContestationDocument &&
      props.requestUploadContestationDocument(
        [props.contestationDocs],
        props.claimNumber,
        props.judgementOnMerits.claimId,
        props.judgementOnMerits.judiciaryProcessId,
        props.judgementOnMerits.validator,
        [],
        props.judgementOnMerits.procedureType,
        props.isLawyer,
        props.handleSuccessCallback,
        contestationNatureId,
        get(props.judgementOnMerits, 'jom.jmc.id'),
      );
    props.resetUploadedDocument();
    setContestationDecisionDoc({
      ...EMPTY_DOCUMENT,
    });
    props.setContestationDocs({});
  };

  return (
    <Container className="subContainer">
      <FormContainer>
        <FormGroup>
          <div style={{ marginLeft: '-13px' }}>
            <InputLabel>{translate(messages.decision, props)}</InputLabel>

            <Select
              data-testid="checkboxId"
              value={contestationNatureTitle}
              onChange={onChangeSelect}
              style={{ width: '200px' }}
              disabled={props.disabled}
            >
              {get(
                props.listings,
                'judgementOnMeritsContestationNature',
                [],
              ).map((item: any, index: number) => (
                <MenuItem value={item.id} key={index}>
                  {item.title}
                </MenuItem>
              ))}
            </Select>
          </div>
          {showAmount && (
            <ProvisionAmountForm
              judgementOnMerits={props.judgementOnMerits}
              setContestationDecision={setContestationDecision}
              contestationDecision={contestationDecision}
              decisionDocumentToUpdate={decisionDocumentToUpdate}
              contestationDocs={props.contestationDocs}
              setContestationDocs={props.setContestationDocs}
            />
          )}
        </FormGroup>
      </FormContainer>
      <div className="upload-doc-title">
        {translate(messages.uploadOppositionDecisionDocumentTitle, props)}
      </div>
      <div className="item-row">
        {(props.isCivilProceeding || props.isLawyer) && (
          <UploadDocumentBloc
            index={0}
            docType={`${
              DOCUMENT_TYPES.CONTESTATION
            } ${findContestationNatureTitle(
              get(props.listings, 'judgementOnMeritsContestationNature', []),
              contestationNatureTitle,
            )}`}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            setDocumentId={props.setDocumentId}
            setDocument={setContestationDecisionDocument}
            document={contestationDecisionDoc}
            docId={CONTESTATION_ID}
          />
        )}
        <div>
          {props.decisionDocuments.map(
            (decisionDocument: CorporealDocument) => (
              <Document
                name={decisionDocument.name}
                type={decisionDocument.type}
                icon={
                  <div
                    className="consult"
                    onClick={handleOpenDocument(
                      decisionDocument as any,
                      props.requestGetDocByDocumentumId,
                    )}
                  >
                    <View />
                  </div>
                }
              />
            ),
          )}
        </div>
      </div>

      {(get(props.judgementOnMerits, 'jom.jmc.status') === STATUS_REJECTED ||
        get(props.judgementOnMerits, 'jom.jmc.status') === STATUS_PENDING) &&
        !props.disabled && (
          <div className="subContainer">
            <PrimaryButton
              className="validate-button"
              data-testid="validate"
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              title={translate(messages.validateButton, props)}
              disabled={!props.contestationDocs?.url}
              onClick={validateUpload}
            />
            <SecondaryButton
              title={translate(messages.cancelButton, props)}
              data-testid="go-back"
            />
          </div>
        )}
    </Container>
  );
};

export default injectIntl(ContestionDecisionForm);
